var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9842 7.99993C11.9842 9.64994 10.6509 10.9833 9.00091 10.9833C7.35091 10.9833 6.01758 9.64994 6.01758 7.99993C6.01758 6.34993 7.35091 5.0166 9.00091 5.0166C10.6509 5.0166 11.9842 6.34993 11.9842 7.99993Z",
    stroke: "#020842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99987 14.8918C11.9415 14.8918 14.6832 13.1584 16.5915 10.1584C17.3415 8.98343 17.3415 7.00843 16.5915 5.83343C14.6832 2.83343 11.9415 1.1001 8.99987 1.1001C6.0582 1.1001 3.31654 2.83343 1.4082 5.83343C0.658203 7.00843 0.658203 8.98343 1.4082 10.1584C3.31654 13.1584 6.0582 14.8918 8.99987 14.8918Z",
    stroke: "#020842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_eye.26f69fa239b35927cd89b3b283039b33.svg";
export { ForwardRef as ReactComponent };